import React, { useEffect } from 'react'
import clsx from 'clsx'
import { Container, Grid, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import Layout from '../components/Layout/Layout'
import HeroSection from '../components/Hero/HeroSection'
import Commitment from '../components/Commitment/Commitment'
import useShopStyles from '../components/Shop/Shop.style'
import DateRangeForm from '../components/DateRangeForm/DateRangeForm'
import PacksCatalog from '../components/Packs/PacksCatalog'
import { getPackTaxons } from '../redux/actions/packs'
import { useRouter } from 'next/router'
import { getTranslations } from '../i18n'
import { useTranslation } from 'react-i18next'
import { setFullLocale } from '../utils/utils'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import CMSText, { prismicText } from '../components/Global/CMSText'
import { createClient, getSingleDocument } from '../prismicio'

type Tprops = {
  doc?: any
  main?: any
  funnel?: any
  taxonPack?: any
  shopText?: any
  getPackTaxons?: any
  parameters?: any
  takeback: any
  inStoreText: any
  basket: any
  accountRes?: any
  faqRes?: any
  banner?: any
}

const mapStateToProps = (state) => ({
  taxonPack: state.taxonPack,
  parameters: state.parameters,
})

const mapDispatchToProps = {
  getPackTaxons: getPackTaxons,
}

const Packs = ({
  doc,
  main,
  funnel,
  taxonPack,
  getPackTaxons,
  inStoreText,
  parameters,
  takeback,
  shopText,
  basket,
  accountRes,
  faqRes,
  banner,
}: Tprops) => {
  const LayoutStyle = {}
  const classes = useShopStyles(LayoutStyle)
  const { t } = useTranslation()
  const router = useRouter()

  const { trackPageView } = useMatomo()
  const isSubscription =
    process.env.STORE_TYPE === 'subscription' ||
    process.env.STORE_TYPE === 'classic_subscription'

  const settings = main?.data
  const isEnableChooseStartingDate = parameters?.items?.enableChooseStartingDate

  useEffect(() => {
    trackPageView({ documentTitle: 'Packs' })
  }, [])

  useEffect(() => {
    if (main?.data?.pack_page === false) {
      router.push('/shop')
    }
    if (typeof taxonPack.items === 'undefined') {
      getPackTaxons()
    }
  }, [])

  return (
    <Layout
      mainLogo={main?.data?.logo}
      doc={main}
      t={t}
      inStoreText={inStoreText}
      metaTitle={prismicText(
        doc?.data?.meta_title_packs,
        t('texts:general:herotitle')
      )}
      metaDescription={doc?.data?.meta_description_packs}
      metaKeywords={doc?.data?.meta_keywords_packs}
      basket={basket}
      takeback={takeback}
      account={accountRes}
      faq={faqRes}
      banner={banner}
    >
      <main className={`main main--pack ${classes.root}`}>
        <HeroSection
          title={prismicText(
            doc?.data?.herotitle,
            t('texts:general:herotitle')
          )}
          isMainTitle
          topTitle={prismicText(doc?.data?.hero_top_title)}
          heroImg={main?.data?.hero_banner}
          heroSettings={main?.data}
        />
        <section className={clsx('shop__content', classes.shopContent)}>
          <Container maxWidth="xl" className={classes.shopContainer}>
            <div
              className={clsx(
                'shop__planner',
                classes.shopPlanner,
                !isSubscription && classes.shopPlannerDad,
                isSubscription && classes.noBoxShadow
              )}
            >
              {!isSubscription || isEnableChooseStartingDate ? (
                <DateRangeForm
                  text={main?.data}
                  textFunnel={funnel?.data}
                  t={t}
                  parameters={parameters}
                  scrollTarget={'catalog'}
                />
              ) : (
                <>
                  {doc?.data?.has_shipping_card && (
                    <Grid container spacing={9}>
                      <Grid item sm={12} md={6}>
                        <Typography component="p" variant="h3">
                          {prismicText(
                            doc?.data?.titlepacks,
                            t('texts:packs:titlepacks')
                          )}
                        </Typography>
                        <Typography component="div" variant="body1">
                          <CMSText
                            data={doc?.data?.packsparagraph}
                            defaultText={t('texts:packs:packsparagraph')}
                          />
                        </Typography>
                      </Grid>
                      <Grid item sm={12} md={6}>
                        <Commitment
                          icon={
                            doc?.data?.image_shipping_section?.url
                              ? doc.data.image_shipping_section.url
                              : null
                          }
                          desc={
                            <CMSText
                              data={doc?.data?.shipping_description}
                              defaultText={t(
                                'texts:packs:shipping_description'
                              )}
                            />
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </div>
            <Container maxWidth="xl" className={classes.shopArea}>
              {!isSubscription && (
                <div className={classes.shopIntro}>
                  {doc?.data?.has_shipping_card && (
                    <Grid container spacing={9}>
                      <Grid item sm={12} md={6}>
                        <Typography component="p" variant="h3">
                          {prismicText(
                            doc?.data?.titlepacks,
                            t('texts:packs:titlepacks')
                          )}
                        </Typography>
                        <Typography component="p" variant="body1">
                          {prismicText(
                            doc?.data?.packsparagraph,
                            t('texts:packs:packsparagraph')
                          )}
                        </Typography>
                      </Grid>
                      <Grid item sm={12} md={6}>
                        <Commitment
                          icon={
                            doc?.data?.image_shipping_section?.url
                              ? doc.data.image_shipping_section.url
                              : null
                          }
                          desc={
                            <CMSText
                              data={doc?.data?.shipping_description}
                              defaultText={t(
                                'texts:packs:shipping_description'
                              )}
                            />
                          }
                        />
                      </Grid>
                    </Grid>
                  )}
                </div>
              )}
              <PacksCatalog
                t={t}
                shopText={shopText}
                taxonsPacks={taxonPack.items}
                text={doc?.data}
                settings={settings}
                takeback={takeback}
              />
            </Container>
          </Container>
        </section>
      </main>
    </Layout>
  )
}

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const packs = await getSingleDocument(client, lang, 'packs')
  const basket = await getSingleDocument(client, lang, 'basket')
  const general = await getSingleDocument(client, lang, 'general')
  const takeback = await getSingleDocument(client, lang, 'take_back')
  const shop = await getSingleDocument(client, lang, 'shop')
  const funnel = await getSingleDocument(client, lang, 'funnel')
  const inStoreText = await getSingleDocument(client, lang, 'instore')
  const accountRes = await getSingleDocument(client, lang, 'account')
  const faqRes = await getSingleDocument(client, lang, 'faq')
  const banner = await getSingleDocument(client, lang, 'banner')

  return {
    props: {
      doc: packs,
      main: general,
      takeback,
      basket,
      inStoreText,
      accountRes,
      faqRes,
      funnel,
      shopText: shop,
      banner,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Packs)
